// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-employee-custom{
	height: 130px;
}
.w-49{
	width: 49%;
}
.w-45{
	width: 45%;
}
.employee-customer-public-info{
    -moz-column-count: 2;
         column-count: 2;
    -moz-column-gap: 5%;
         column-gap: 5%;
    -moz-column-fill: auto;
         column-fill: auto;
}

.padding-address{
	padding-left: 15px;
}

.user-name{
	font-style: normal;
	font-weight: 700;
	font-size: 2rem;
	color: #252929;
}

.text-muted{
	font-style: normal;
	font-weight: 400;
	font-size: 1.2rem;
	color: #A8A9A9!important;
}

.unset-margin{
	margin: unset;
}

.btnHistory{
	font-size: 1rem;
	margin-right: 10px;
	text-decoration: underline;
	color: #1B8FC3;
	cursor: pointer;
}

.card {
	margin-top: 1.5rem
}

.label-larger {
	font-size: larger;
}

/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImVtcGxveWVlLXByb2ZpbGUuY29tcG9uZW50LmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtDQUNDLGFBQWE7QUFDZDtBQUNBO0NBQ0MsVUFBVTtBQUNYO0FBQ0E7Q0FDQyxVQUFVO0FBQ1g7QUFDQTtJQUNJLG9CQUFlO1NBQWYsZUFBZTtJQUNmLG1CQUFjO1NBQWQsY0FBYztJQUNkLHNCQUFpQjtTQUFqQixpQkFBaUI7QUFDckI7O0FBRUE7Q0FDQyxrQkFBa0I7QUFDbkI7O0FBRUE7Q0FDQyxrQkFBa0I7Q0FDbEIsZ0JBQWdCO0NBQ2hCLGVBQWU7Q0FDZixjQUFjO0FBQ2Y7O0FBRUE7Q0FDQyxrQkFBa0I7Q0FDbEIsZ0JBQWdCO0NBQ2hCLGlCQUFpQjtDQUNqQix3QkFBd0I7QUFDekI7O0FBRUE7Q0FDQyxhQUFhO0FBQ2Q7O0FBRUE7Q0FDQyxlQUFlO0NBQ2Ysa0JBQWtCO0NBQ2xCLDBCQUEwQjtDQUMxQixjQUFjO0NBQ2QsZUFBZTtBQUNoQjs7QUFFQTtDQUNDO0FBQ0Q7O0FBRUE7Q0FDQyxpQkFBaUI7QUFDbEIiLCJmaWxlIjoiZW1wbG95ZWUtcHJvZmlsZS5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLnByb2ZpbGUtZW1wbG95ZWUtY3VzdG9te1xyXG5cdGhlaWdodDogMTMwcHg7XHJcbn1cclxuLnctNDl7XHJcblx0d2lkdGg6IDQ5JTtcclxufVxyXG4udy00NXtcclxuXHR3aWR0aDogNDUlO1xyXG59XHJcbi5lbXBsb3llZS1jdXN0b21lci1wdWJsaWMtaW5mb3tcclxuICAgIGNvbHVtbi1jb3VudDogMjtcclxuICAgIGNvbHVtbi1nYXA6IDUlO1xyXG4gICAgY29sdW1uLWZpbGw6IGF1dG87XHJcbn1cclxuXHJcbi5wYWRkaW5nLWFkZHJlc3N7XHJcblx0cGFkZGluZy1sZWZ0OiAxNXB4O1xyXG59XHJcblxyXG4udXNlci1uYW1le1xyXG5cdGZvbnQtc3R5bGU6IG5vcm1hbDtcclxuXHRmb250LXdlaWdodDogNzAwO1xyXG5cdGZvbnQtc2l6ZTogMnJlbTtcclxuXHRjb2xvcjogIzI1MjkyOTtcclxufVxyXG5cclxuLnRleHQtbXV0ZWR7XHJcblx0Zm9udC1zdHlsZTogbm9ybWFsO1xyXG5cdGZvbnQtd2VpZ2h0OiA0MDA7XHJcblx0Zm9udC1zaXplOiAxLjJyZW07XHJcblx0Y29sb3I6ICNBOEE5QTkhaW1wb3J0YW50O1xyXG59XHJcblxyXG4udW5zZXQtbWFyZ2lue1xyXG5cdG1hcmdpbjogdW5zZXQ7XHJcbn1cclxuXHJcbi5idG5IaXN0b3J5e1xyXG5cdGZvbnQtc2l6ZTogMXJlbTtcclxuXHRtYXJnaW4tcmlnaHQ6IDEwcHg7XHJcblx0dGV4dC1kZWNvcmF0aW9uOiB1bmRlcmxpbmU7XHJcblx0Y29sb3I6ICMxQjhGQzM7XHJcblx0Y3Vyc29yOiBwb2ludGVyO1xyXG59XHJcblxyXG4uY2FyZCB7XHJcblx0bWFyZ2luLXRvcDogMS41cmVtXHJcbn1cclxuXHJcbi5sYWJlbC1sYXJnZXIge1xyXG5cdGZvbnQtc2l6ZTogbGFyZ2VyO1xyXG59XHJcbiJdfQ== */`, "",{"version":3,"sources":["webpack://./src/app/all-modules/employees/employee-profile/employee-profile.component.css"],"names":[],"mappings":"AAAA;CACC,aAAa;AACd;AACA;CACC,UAAU;AACX;AACA;CACC,UAAU;AACX;AACA;IACI,oBAAe;SAAf,eAAe;IACf,mBAAc;SAAd,cAAc;IACd,sBAAiB;SAAjB,iBAAiB;AACrB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,eAAe;CACf,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB;CACjB,wBAAwB;AACzB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,eAAe;CACf,kBAAkB;CAClB,0BAA0B;CAC1B,cAAc;CACd,eAAe;AAChB;;AAEA;CACC;AACD;;AAEA;CACC,iBAAiB;AAClB;;AAKA,g2DAAg2D","sourcesContent":[".profile-employee-custom{\r\n\theight: 130px;\r\n}\r\n.w-49{\r\n\twidth: 49%;\r\n}\r\n.w-45{\r\n\twidth: 45%;\r\n}\r\n.employee-customer-public-info{\r\n    column-count: 2;\r\n    column-gap: 5%;\r\n    column-fill: auto;\r\n}\r\n\r\n.padding-address{\r\n\tpadding-left: 15px;\r\n}\r\n\r\n.user-name{\r\n\tfont-style: normal;\r\n\tfont-weight: 700;\r\n\tfont-size: 2rem;\r\n\tcolor: #252929;\r\n}\r\n\r\n.text-muted{\r\n\tfont-style: normal;\r\n\tfont-weight: 400;\r\n\tfont-size: 1.2rem;\r\n\tcolor: #A8A9A9!important;\r\n}\r\n\r\n.unset-margin{\r\n\tmargin: unset;\r\n}\r\n\r\n.btnHistory{\r\n\tfont-size: 1rem;\r\n\tmargin-right: 10px;\r\n\ttext-decoration: underline;\r\n\tcolor: #1B8FC3;\r\n\tcursor: pointer;\r\n}\r\n\r\n.card {\r\n\tmargin-top: 1.5rem\r\n}\r\n\r\n.label-larger {\r\n\tfont-size: larger;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
